























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import {QueryUnit,CreateUnit,EditUnit} from '../../../api/basicDictionary'
import myform from '../../../components/form/index.vue'
@Component({
  components:{myTable,myform}
})
export default class extends AbpBase{
    //存储节点load对象，以便刷新传参
    pNodeFun = []
    updateNodeIndex = null;
    async loadNode(node, resolve) {
        console.log(node)
        if (node.level === 0) {
            let res = await this.QuerySysDicType()
            this.list = res.data;
            //设置length为一级菜单长度
            this.pNodeFun.length = res.data.length
            return resolve(this.list);
        }
        //只有点击展开节点时存储
        if(node.level==1){
            this.pNodeFun[node.id-1] = {
                node:node,
                resolve:resolve,
            }
        }
        if (node.level > 1) return resolve([]);
        let cres = await this.QuerySysDic({dataType:node.key,typeName:'',status:true})
        const data = cres.data.map(item => {
            return {
                id:item.id,
                leaf:true,
                pCode:item.dicTableId,
                name:item.typeName,
            }
        });
        //延时效果
        setTimeout(() => {
            resolve(data);
        }, 200);
    }
    treeLoad = true
    props =  {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
    }
    list:Array<object> = []
    formShow:boolean = false
    formTitle:string = ''
    formData:object = {}
    formItem:Array<object> = []

    created() {
        // this.getData()   
    }
    async getData(){
        //重新获取数据，只有节点被展开过时调用
        if(this.pNodeFun[this.updateNodeIndex]){
            this.loadNode(this.pNodeFun[this.updateNodeIndex].node,this.pNodeFun[this.updateNodeIndex].resolve)
        }
    }

    addOrEdit(row:any){
        console.log(row)
        if(row.pCode){
            //判断当前点击的节点下标
            this.list.forEach((item:any,index:any)=>{ item.id == row.pCode ? this.updateNodeIndex = index:null})
            this.formTitle = '编辑'
            this.formData = {
                id:row.id,
                typeName:row.name,
                pCode:1,
                code:'',
                status:true,
            }
        }else{
            //判断当前点击的节点下标
            this.updateNodeIndex = row.$treeNodeId-1
            this.formTitle = '新增'
            this.formData = {
                typeName:'',
                code:'',
                dataType:row.id,
                status:true,
            }
        }
        
        // this.formData = Object.assign(this.formData,row)
        this.formItem = [
            {
                column:24,
                show:true,
                label:'字典名称',
                name:'typeName',
                type:'text',
                placeholder:'请输入字典名称',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ],
            },
            {
                column:24,
                show:true,
                label:'是否激活',
                name:'status',
                type:'switch',
            }
        ]
        this.formShow = true
    }
    async submit(data:any){
        let res;
        if(data.pCode){
            res = await this.QueryEditSysDic(data)
        }else{
            res = await this.QueryCreateSysDic(data)
        }
        if(res.code=2000){
            this.formShow = false
            this.getData()
        }
    }
    async remove(data){
        //判断当前点击的节点下标
        this.list.forEach((item:any,index:any)=>{ item.id == data.pCode ? this.updateNodeIndex = index:null})
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(async () => {
            let res = await this.QueryDeleteSysDic({id:data.id})
            if(res.code==2000){
                this.getData()
            }
        }).catch(() => {
        });

        
    }
}
